import * as React from 'react'

import LocationIcon from '~/client/src/shared/components/LocationIcon/LocationIcon'
import {
  PICTOGRAM_ICONS,
  PICTOGRAM_VIEW_BOX,
  pictogramSlugOf,
} from '~/client/src/shared/icons/pictograms'

import IconPickerTile from './IconPickerTile'

/**
 * A tile for any location icon: a library sign full-bleed, a StruxHub glyph as a line icon.
 * Memoised: a pick or a keystroke would otherwise re-render every tile, ~200 of them.
 */
const IconPickerIconTile = React.memo(function IconPickerIconTile({
  iconName,
  label,
  typeName,
  isSelected,
  onPick,
}: {
  iconName: string
  label: string
  typeName?: string
  isSelected: boolean
  onPick: (iconName: string) => void
}): React.ReactElement {
  const slug = pictogramSlugOf(iconName)
  const Art = slug && PICTOGRAM_ICONS[slug]

  return (
    <IconPickerTile
      label={label}
      typeName={typeName}
      isSelected={isSelected}
      isFullBleed={!!Art}
      onClick={() => onPick(iconName)}
    >
      {Art ? (
        <Art className="tw:size-10" viewBox={PICTOGRAM_VIEW_BOX} />
      ) : (
        <LocationIcon iconName={iconName} className="tw:size-6" />
      )}
    </IconPickerTile>
  )
})

export default IconPickerIconTile
